// !!! This is hardcoded data, it will be deleted when BE endpoint is ready
export const lineGraphData = [50, 240, 220]
